import { render, staticRenderFns } from "./BetslipPossibleWin.vue?vue&type=template&id=65921770&scoped=true"
import script from "./BetslipPossibleWin.vue?vue&type=script&lang=js"
export * from "./BetslipPossibleWin.vue?vue&type=script&lang=js"
import style0 from "./BetslipPossibleWin.vue?vue&type=style&index=0&id=65921770&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65921770",
  null
  
)

export default component.exports